module.exports = "/_next/static/images/fae8f35fe7c83365e4513ee8f959d87d-challenge-the-system-xs@3x.jpg";